import { useIntl } from '@/intl'
import { MediaServerLazyImage } from '@/scopes/common/components/MediaServerLazyImage'
import { Button } from '@sunwebgroup/uds-ui/button'
import { Rating } from '@sunwebgroup/uds-ui/rating'
import { Typography } from '@sunwebgroup/uds-ui/typography'
import { Badge } from '@sunwebgroup/ui-components/uds'
import { useAccoDetailsById } from './hooks'
import styles from './MapAccoCard.module.css'
import { MapAccoCardLoading } from './MapAccoCardLoading'

interface MapAccoCardProps {
  accoId: string
  onBookNowClick?: () => void
}

export function MapAccoCard({ accoId, onBookNowClick }: MapAccoCardProps) {
  const intl = useIntl()

  const { accoDetails, isLoading } = useAccoDetailsById(accoId)

  if (isLoading) {
    return <MapAccoCardLoading />
  }

  if (!accoDetails) {
    return null
  }

  const { name, imageUrl, rating, userRating, breadcrumbs, url } = accoDetails

  return (
    <div className={styles.accoCardContainer}>
      <div className={styles.imageContainer}>
        <MediaServerLazyImage src={imageUrl} alt={name ?? ''} widths={[320]} />
      </div>
      <div className={styles.cardMain}>
        <div className={styles.cardHeader}>
          <div className={styles.ratingWrapper}>
            <Rating rating={rating} />
            {userRating > 0 && <Badge>{userRating}</Badge>}
          </div>
          <div className={styles.accoWrapper}>
            <Typography className={styles.accoName} variant="display-i-regular">
              {name}
            </Typography>
            <Typography className={styles.accoDetails} variant="body-xs-regular-tight">
              {breadcrumbs.join(', ')}
            </Typography>
          </div>
        </div>
        <div className={styles.cardFooter}>
          <Button
            className={styles.styledButton}
            as="a"
            href={url}
            variant="primary"
            onClick={onBookNowClick}
          >
            {intl.formatMessage({ id: 'destination_map_detail_card_cta' })}
          </Button>
        </div>
      </div>
    </div>
  )
}
